export class EpsNewParkingSize {
    vehicle_type_id: number;
    spot_type_id: number;
    number_of_spots: number
    oversell_ratio: number
}